<div class="picture-user">
  <img *ngIf="userPicture && userPicture != ''" loading="lazy" class="content"
       src="{{userPicture}}"
       alt="Image de l'utilisateur {{textForOneLetter}}"/>
  <div *ngIf="!userPicture || userPicture == ''"
       class="content color-{{textForOneLetter.charCodeAt(0) % 5}}">
    {{textForOneLetter ? textForOneLetter.charAt(0).toUpperCase() : 'A'}}
  </div>
</div>
